/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import PropertySetter from './PropertySetter';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertySetter (runtime) // resolveIdForExpression

/**
 * The base metadata object. used as base object class in JAVA code for tree walking. <p>Java class for baseObjectType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="baseObjectType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="idForExpression" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="property" type="{}propertyType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class BaseObjectType extends MoserObject{

	idForExpression = null;

	property = null;



	/**
	 * Gets the value of the idForExpression property.
	 * @return {String} possible object is {@link String}
	 */
	getIdForExpression() {
		if (this.idForExpression == null) {
			PropertySetter.resolveIdForExpression(this);
		}
		return this.idForExpression;
	}

	/**
	 * Sets the value of the idForExpression property.
	 * @param {String} value allowed object is {@link String}
	 */
	setIdForExpression(value) {
		var oldValue = this.idForExpression;
		this.idForExpression = value;
		this._setAndNotify(129, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the property property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the property property. <p> For example, to add a new item, do as follows: <pre> getProperty().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link PropertyType}
	 */
	getProperty() {
		if (!this.property) {
			this.property = [];
		}
		return this.property;
	}

	/**
	 * Gets the value of the <code>property</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>PropertyType</code> elements, or <code>null</code> if not set
	 */
	basicGetProperty() {
		return this.property;
	}

	/**
	 * Creates a new instance of <code>BaseObjectType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> BaseObjectType</code> object from.
	 * @return {BaseObjectType} an object of type <code>BaseObjectType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createBaseObjectType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addPropertyAt(position, item) {
		this._addAtAndNotify(this.getProperty(), position, item, 96, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addProperty(item) {
		this.addPropertyAt(this.getProperty().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removePropertyAt(position) {
		this._removeAtAndNotify(this.getProperty(), position, 96, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeProperty(item) {
		var i = this.getProperty().indexOf(item);
		if (i >= 0) {
			this.removePropertyAt(i);
		}
	}

	basicGetIdForExpression() {
		return this.idForExpression;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "BaseObjectType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 129, "idForExpression", null));
		var clazz;
		if (factory) {
			clazz = factory.createPropertyType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 96, "property", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 129:
			this.setIdForExpression((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 96:
			this.property = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 129:
			return this.getIdForExpression();
		case 96:
			return this.getProperty();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 129:
			return this.basicGetIdForExpression();
		case 96:
			return this.basicGetProperty();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 96:
			this.addPropertyAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 96:
			this.addProperty((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 96:
			this.removePropertyAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 96:
			this.removeProperty((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/BaseObjectType.js